<template>
	<div class="carousel carousel--compact">
		<button
			class="carousel__showlarge-button"
			:aria-label="
				arialabelcarouselshowlargeimages + (title ? ': ' + title : '')
			"
		>
			{{ arialabelcarouselshowlargeimages }}
		</button>
		<div class="carousel__click-outside"></div>
		<div class="carousel__wrapper">
			<button
				class="carousel__close-button button--nostyling"
				:aria-label="arialabelcarouselclosebutton"
			>
				<span v-html="IconCross"></span>
			</button>
			<div class="carousel__track">
				<div
					class="carousel__slide"
					v-for="(image, index) in images"
					:key="index + image"
					v-html="image"
				></div>
			</div>
			<div class="carousel__dots">
				<button
					v-for="(image, index) in images"
					:key="index + image"
					class="carousel__dot button--nostyling"
					:aria-label="
						arialabelcarouseldotbutton
							.replace('X', index + 1)
							.replace('Y', images.length)
					"
				></button>
			</div>
			<div class="carousel__controls text--center">
				<button
					class="carousel__btn carousel__prev-btn button--nostyling"
					:aria-label="arialabelprevious"
				>
					<span v-html="IconArrow"></span>
				</button>
				<button
					class="carousel__btn carousel__next-btn button--nostyling"
					:aria-label="arialabelnext"
				>
					<span v-html="IconArrow"></span>
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted } from 'vue';
import Carousel from "./carousel.js";
import IconCross from "../../../views/icons/cross.cshtml";
import IconArrow from "../../../views/icons/arrow.cshtml";

const props = defineProps({
	images: {
		type: Array,
		default: () => []
	},
	arialabelcarouselshowlargeimages: {
		type: String
	},
	arialabelcarouseldotbutton: {
		type: String
	},
	arialabelcarouselclosebutton: {
		type: String
	},
	arialabelnext: {
		type: String
	},
	arialabelprevious: {
		type: String
	},
	title: {
		type: String,
		default: ""
	}
});

onMounted(() => {
	utilities.initComponent(Carousel, {
		el: ".hybridlist-item__carousel"
	});
});
</script>
